import Indicator from '../Indicator';

/** Up/Down Ratio indicator */
export default class UpDownRatioIndicator extends Indicator {
	/**
	 * Returns the default params for this type of indicator. Overrides abstract
	 * method inherited from Indicator.
	 * @returns {object} - Default parameters object
	 * @property {string} id - Indicator ID
	 * @property {string} name - Indicator name
	 */
	_getDefaultParams() {
		return {
			id: 'updownratio',
			name: 'Up/Down Ratio',
			description: 'The Up/Down ratio indicator shows the relationship between the volume of advancing issues and the volume of declining issues. Upside volume is simply the sum of all volume associated with stocks that closed up in price, while downside volume is the sum of all volume associated with stocks that closed down in price.',
			inputs: [
				{ name: 'Numerator', value: 10025197 },
				{ name: 'Denominator', value: 10025198 }
			]
		};
	}

	/** @param {object} data Symbol data object */
	render(data, sessionType) {
		this._renderLineMarker({
			data: data[this.params.id],
			sessionType
		});
	}
}
